module.exports = __webpack_public_path__ + "static/media/ares.035fe627.png";